// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colours to be used */
/* Everything related to the Internationalization view */
/* Everything related to the Installation view */
/* Everything related to the navbar */
/* Everything related to alarm page list */
/* Everything related to alarm logs page */
/* Everything related to PWR table */
/*  */
.Login_login-wrapper__W20ku {
  margin-top: 5rem;
  margin-left: 5rem;
  width: 30rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.Login_login-wrapper__W20ku .Login_login-content__\\+dzqQ {
  display: flex;
  flex-direction: column;
}
@media (max-width: 768px) {
  .Login_login-wrapper__W20ku {
    margin-left: 2rem;
    width: 20rem;
  }
}
@media (max-width: 370px) {
  .Login_login-wrapper__W20ku {
    margin-left: 1rem;
    width: 16rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/utils/_utils.scss","webpack://./src/containers/Login.module.scss"],"names":[],"mappings":"AAAA,uBAAA;AAEA,wDAAA;AAGA,gDAAA;AAMA,qCAAA;AASA,0CAAA;AAKA,0CAAA;AAGA,oCAAA;AAMA,KAAA;AChCA;EACI,gBAAA;EACA,iBAAA;EACA,YAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;AAMJ;AALI;EACI,aAAA;EACA,sBAAA;AAOR;AD4BE;EC7CF;IAcQ,iBAAA;IACA,YAAA;EAON;AACF;ADiCE;ECxDF;IAkBQ,iBAAA;IACA,YAAA;EASN;AACF","sourcesContent":[null,"/* Colours to be used */\n/* Everything related to the Internationalization view */\n/* Everything related to the Installation view */\n/* Everything related to the navbar */\n/* Everything related to alarm page list */\n/* Everything related to alarm logs page */\n/* Everything related to PWR table */\n/*  */\n.login-wrapper {\n  margin-top: 5rem;\n  margin-left: 5rem;\n  width: 30rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.login-wrapper .login-content {\n  display: flex;\n  flex-direction: column;\n}\n@media (max-width: 768px) {\n  .login-wrapper {\n    margin-left: 2rem;\n    width: 20rem;\n  }\n}\n@media (max-width: 370px) {\n  .login-wrapper {\n    margin-left: 1rem;\n    width: 16rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"login-wrapper": `Login_login-wrapper__W20ku`,
	"login-content": `Login_login-content__+dzqQ`
};
export default ___CSS_LOADER_EXPORT___;
